<template>
  <div class="account-manage">
    <Form :model="formItem" :label-width="65">
      <FormItem label="中心名称:">
        <Row>
          <Col span="4"
            ><Input
              v-model="formItem.input"
              placeholder="请输入"
              clearable
              style="width: 100%"
              @on-enter="select"
            />
          </Col>
          <Col span="1" style="margin: 0px 0 0 10px">
            <Button type="primary" @click="select">查询</Button>
          </Col>
          <Col span="1" offset="17">
            <Button class="new" @click="newset">+ 新建</Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
    <Row>
      <Col span="24">
        <Table ref="selection" :columns="columns1" :data="data1">
          <template slot-scope="{ row, index }" slot="action">
            <a
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="show(row, index)"
              >查看</a
            >
            <a type="error" size="small" @click="remove(index, row)">删除</a>
          </template>
        </Table>
      </Col>
    </Row>

    <div class="pagination">
      <Page
          :total="total"
          :current="current"
          show-total
          show-sizer
          @on-change="get1"
          @on-page-size-change="get"
          show-elevator
        />
    </div>
        

    <Modal v-model="modal" width="800">
      <p slot="header" style="text-align: left">
        <Icon type="ios-square" style="color: #0073d3"></Icon>
        <b>&nbsp;{{ this.modalname }}</b>
      </p>
      <div style="text-align: center">
        <Form
          style="padding: 0 20px 0 20px"
          ref="formItem1"
          :model="formItem1"
          :rules="rule"
        >
          <Row>
            <Col span="8"
              ><FormItem label="中心名称" prop="centername">
                <Input
                  :disabled="disabled"
                  v-model="formItem1.centername"
                  placeholder="请填写中心名称"
                  style="width: 100%" /></FormItem
            ></Col>
            <Col span="8" offset="1"
              ><FormItem label="中心账号" prop="centeraccount">
                <Input
                  :disabled="newsetdisabled"
                  v-model="formItem1.centeraccount"
                  placeholder="请填写中心账号"
                  style="width: 100%" /></FormItem
            ></Col>
          </Row>
          <Row style="margin-top: 10px">
            <Col span="8"
              ><FormItem label="密码" prop="centerpwd">
                <Input
                  :disabled="newsetdisabled"
                  type="password"
                  password
                  v-model="formItem1.centerpwd"
                  placeholder="请填写密码"
                  style="width: 100%" /></FormItem
            ></Col>
            <Col span="8" offset="1"
              ><FormItem label="确认密码" prop="centerrepwd">
                <Input
                  :disabled="newsetdisabled"
                  type="password"
                  password
                  v-model="formItem1.centerrepwd"
                  placeholder="请再输入一遍密码以确认"
                  style="width: 100%" /></FormItem
            ></Col>
          </Row>
          <Row style="margin-top: 10px">
            <Col span="8"
              ><FormItem label="医院" prop="centerhospital">
                <Select
                  :filterable="true"
                  clearable
                  :loading="isHosLoading"
                  :remote-method="searchHospital"
                  :disabled="disabled"
                  v-model="formItem1.centerhospital"
                  placeholder="请选择/输入医院"
                  style="width: 100%; text-align: left"
                  @on-change="selected"
                >
                  <Option
                    v-for="item in hospitalList"
                    :value="item.OrgName"
                    :key="item.ID"
                    >{{ item.OrgName }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="8" offset="1"
              ><FormItem label="科室" prop="centerdepartment">
                <Select
                  filterable
                  clearable
                  :disabled="disabled"
                  v-model="formItem1.centerdepartment"
                  placeholder="请选择/输入科室"
                  style="width: 100%; text-align: left"
                >
                  <Option
                    v-for="item in departmentList"
                    :value="item.DepartmentName"
                    :key="item.ID"
                    >{{ item.DepartmentName }}</Option
                  >
                </Select></FormItem
              ></Col>
          </Row>
          <Row>
              <Col span="17" offset="0">
                <FormItem label="中心简介" prop="centerIntro">
                    <Input
                      :disabled="disabled"
                      type="textarea"
                      :autosize="{minRows: 3,maxRows: 5}"
                      v-model="formItem1.centerIntro"
                      placeholder="请再输入.."/>
                </FormItem>
              </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <Button
          type="default"
          size="large"
          style="width: 150px; border-color: #1890ff; color: #1890ff"
          @click="edit"
          v-show="ifshow"
          >编辑</Button
        >
        <Button
          type="default"
          size="large"
          style="width: 150px; border-color: #1890ff; color: #1890ff"
          @click="cancle"
          v-show="ifedit"
          >取消</Button
        >
        <Button
          type="primary"
          size="large"
          style="width: 150px"
          @click="save('formItem1')"
          v-show="!ifshow"
          :loading="saveLoading"
          >保存</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import Request from "../utils/request";
import config from "../config/index.js";
import {
  Form,
  FormItem,
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Icon,
  Select,
  Option,
  Page,
  Spin,
} from "view-design";
export default {
  components: {
    Form,
    FormItem,
    Input,
    Row,
    Col,
    Button,
    Table,
    Modal,
    Icon,
    Select,
    Option,
    Page,
    Spin,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空！"));
      } else {
        if (this.formItem1.centerrepwd !== "") {
          // 对第二个密码框单独验证
          this.$refs.formItem1.validateField("centerrepwd");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请在此输入您的密码！"));
      } else if (value !== this.formItem1.centerpwd) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        callback();
      }
    };
    return {
      saveLoading: false,
      isHosLoading: false,
      isDepLoading: true,
      ID: "",
      total: 100,
      pageSize:10,
      current: 1,
      hospitalList: [],
      departmentList: [],
      modalname: "",

      newsetdisabled: true,
      disabled: false,
      ifshow: false,
      ifedit: false,
      modal: false,
      rule: {
        centername: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
        ],
        centeraccount: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
          // {
          //   required: true,
          //   message: "输入正确账号！",
          //   trigger: "blur",
          //   type: "string",
          // },
        ],
        centerpwd: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        centerrepwd: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
          {
            validator: validatePassCheck,
            trigger: "blur",
          },
        ],
        centerhospital: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
        ],
        centerdepartment: [
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          },
        ],
        centerIntro:[
          {
            required: true,
            message: "不能为空！",
            trigger: "blur",
          }
        ],
      },
      formItem1: {
        centername: "",
        centeraccount: "",
        centerpwd: "",
        centerrepwd: "",
        centerhospital: "",
        centerdepartment: "",
        centerIntro:"",
      },
      formItem: {
        input: "",
      },
      columns1: [
        
        {
          type: 'index',
          width: 300,
          align: 'left',
          title:'序号'
        },
        {
          title: "中心名称",
          key: "Team",
        },
        {
          title: "账号",
          key: "Account",
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
        },
      ],
      data1: [
        {
          number: "1",
          name: "示例1",
          account: 12154548,
        },
        {
          number: "2",
          name: "示例2",
          account: 477455521,
        },
      ],
    };
  },
  created() {
    this.$emit("funChangeTitle", "多中心账号管理", "3-3");
    this.getDatas(this.current,this.pageSize);
  },
  mounted() {},
  methods: {
    //增加与修改中心账号
    addOrChange(ID) {
      let HealthOrgID = "";
      let DeptID = "";
      this.hospitalList.map((item) => {
        if (item.OrgName == this.formItem1.centerhospital) {
          HealthOrgID = item.ID;
        }
        this.departmentList.map((item) => {
          if (item.DepartmentName == this.formItem1.centerdepartment) {
            DeptID = item.ID;
          }
        });
      });
      this.saveLoading = true;
      Request.postRequest(
        config.SXG_baseUrl + "/api/docmanager/RegistMedcareUserForCenter",
        {
          Team: this.formItem1.centername,
          Account: this.formItem1.centeraccount,
          Pws: this.formItem1.centerpwd,
          HealthOrgID,
          DeptID,
          DepartmentName: this.formItem1.centerdepartment,
          CenterName: this.formItem1.centerhospital,
          Introduction:this.formItem1.centerIntro,
          Role: "中心管理员",
          RoleID: 2,
          ID: ID,
        }
      ).then((res) => {
        if (res.code == 200) {
            // console.log(res);
            Request.postRequest(config.SXG_baseUrl+"/api/docmanager/PostAddPlatformRole",{
              UserJid:res.data.UserJid,
              RoleID:2
            }).then((res)=>{
            if(res.code == 200){
            this.$Message.success("成功！");
            this.saveLoading = false;
            this.modal = false;
            this.getDatas(this.current,this.pageSize);
              }else{
                this.$Message.info(res.message)
              }
            })
        } else if (res.code == 300) {
          this.$Message.info(res.message);
          this.saveLoading = false;
        }
      });
    },
    //分页查询中心账号
    getDatas(pageNum, pageSize,searchvalue) {
      Request.getRequest(config.SXG_baseUrl + "/api/currency/GetRecordByPage", {
        tablename: "CenterHospital",
        pageNum: pageNum,
        pageSize: pageSize,
        searchkey: "Team",
        searchvalue: searchvalue,
      }).then((res) => {
        if (res.code == 200) {
          // console.log(res);
          if (res.data.Record.length > 0) {
            this.data1 = res.data.Record;
            this.total = res.data.count;
          } else {
            this.data1 = [];
          }
        }
      });
    },
    //获取医院列表
    getHospitalDatas(val) {
      this.isHosLoading = true;
      Request.postRequest(
        config.SXG_baseUrl + "/api/docmanager/GetAllHospitalsByFilter",
        { sFilter: val }
      ).then((res) => {
        if (res.code == 200) {
          this.isHosLoading = false;
          // console.log(res);
          if (res.data.length > 0) {
            this.hospitalList = res.data;
            // this.hospitalList = res.data.map((item) => {
            //   return {
            //     value: item.OrgName,
            //     label: item.HealthOrgID,
            //   };
            // });
          }
        }
      });
    },
    //获取科室列表
    getDepartmentDatas(hos) {
      if (hos) {
        let HealthOrgID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == hos) {
            HealthOrgID = item.ID;
          }
        });
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/GetDepartmentsByFilter",
          { sFilter: HealthOrgID }
        ).then((res) => {
          if (res.code == 200) {
            this.isDepLoading = false;
            // console.log(res, "---");
            this.formItem1.centerdepartment = "";
            this.departmentList = res.data;
          }
        });
      }
    },
    searchHospital(val) {
      this.getHospitalDatas(val);
    },
    selected(i) {
      // console.log(i);
      this.getDepartmentDatas(i);
    },
    select() {
      // console.log("查询");
      this.getDatas(this.current, this.pageSize,this.formItem.input);
    },
    show(row, index) {
      // console.log(row)
      this.ID = row.ID;
      this.$refs.formItem1.resetFields();
      // console.log(row, "row");
      this.saveLoading = false;
      this.newsetdisabled = true;
      this.disabled = true;
      this.modal = true;
      this.ifshow = true;
      this.ifedit = false;
      this.modalname = "查看中心详情";
      //回填
      this.formItem1.centername = row.Team;
      this.formItem1.centeraccount = row.Account;
      this.formItem1.centerpwd = row.Pws;
      this.formItem1.centerrepwd = row.Pws;
      this.formItem1.centerIntro = row.Introduction;
      //   console.log(index);
      Request.postRequest(
        config.SXG_baseUrl + "/api/docmanager/GetAllHospitalsByFilter",
        {
          sFilter: row.CenterName,
        }
      ).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.hospitalList = res.data;
          this.formItem1.centerhospital = row.CenterName;
          Request.postRequest(
            config.SXG_baseUrl + "/api/docmanager/GetDepartmentsByFilter",
            {
              sFilter: row.HealthOrgID,
            }
          ).then((res) => {
            // console.log(res)
            if (res.code == 200) {
              this.departmentList = res.data;
              this.formItem1.centerdepartment = row.DepartmentName;
              this.remoteFlag = true;
            } else {
              this.$Message.error(res.message);
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    remove(index, row) {
      // console.log(row);
      this.$Modal.confirm({
                    title: '确定要删除吗？',
                    onOk: () => {
                        this.ID = row.ID;
                        this.ok()
                    },
                    onCancel: () => {
                        // this.$Message.info('点击了取消！');
                    }
                });
    },
    ok() {
      Request.postRequest(config.SXG_baseUrl + "/api/currency/DeleteRecord", {
        ID: this.ID,
        tablename: "CenterHospital",
        type: "1",
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.info("删除成功！");
          this.getDatas(this.current,this.pageSize);
        } else {
          this.$Message.info("删除失败！");
        }
      });
    },
    get(num){
      this.getDatas(this.current,num)
    },
    get1(num){
      this.getDatas(num,this.pageSize)
    },
    newset() {
      this.ID = "";
      // console.log(this.ID);
      //   console.log("新建");
      this.newsetdisabled = false;
      this.disabled = false;
      this.saveLoading = false;
      this.modal = true;
      this.ifshow = false;
      this.ifedit = false;
      this.$refs.formItem1.resetFields();
      this.departmentList = [];
      this.hospitalList = [];
      this.modalname = "新增中心";
    },
    edit() {
      console.log(this.ID);
      this.saveLoading = false;

      this.disabled = false;
      this.modalname = "编辑中心详情";
      this.ifedit = true;
      this.ifshow = false;
      // console.log(this.formItem1.centeraccount);
    },
    cancle() {
      this.ifedit = false;
      this.disabled = true;
      this.ifshow = true;
      this.modalname = "查看中心详情";
    },
    save(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.success("Success!");
          this.addOrChange(this.ID);
        } else {
          this.$Message.error("请正确填写完整！");
        }
      });
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="less">
.account-manage {
   padding: 24px 32px 40px 32px;
  width: 100%;
  .ivu-page-item-active a,
  .ivu-page-item-active:hover a {
    color: #fff;
  }
  .ivu-page-item-active {
    background: #2d8cf0;
  }
  //   background: green;
 
  .ivu-form-item-label {
    text-align: left;
    padding-right: 0;
  }
  .new {
    border-color: #1890ff;
    color: #1890ff;
  }
  .ivu-modal-header {
    border-bottom: 0px solid #000 !important;
  }
  .pagination {
    margin-top: 20px;
    margin-left: 70%;
    // position: fixed;
    // bottom: 210px;
    // right: 100px;
  }
}
</style>